<template lang="pug">
  .d-flex.align-items-center.btn(
    v-tooltip="tooltipOptions"
    :class="clickable ? '' : 'cursor-default min-w-unset'"
    :data-toggle="clickable ? 'dropdown' : null"
    :data-original-title="title"
  )
    span
      | {{ activeTimeZone.abbr }}
    i.hi.hi-caret.hi-10.ml-5(v-if="clickable")
</template>
<script>
export default {
  name: 'AppTimeZone',
  props: {
    // ActiveTimeZone object
    activeTimeZone: {
      type: Object,
      default: () => ({}),
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    tooltipOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    title() {
      const displayName = this.activeTimeZone.display_name || '';
      const offset = this.activeTimeZone.offset || '';

      return displayName && offset ? `${displayName} (${offset})` : '';
    },
  },
};
</script>
